export default __webpack_public_path__ + "static/media/gesture.9cb23868.svg";